export * from '@primeuix/themes/material/select';
export { default } from '@primeuix/themes/material/select';
